// extracted by mini-css-extract-plugin
export default {"pageHeader":"page-header_pageHeader__WJ6Dh"};